import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherData, RespResumeOtherDataAttachmentList } from '../../../../item/ItemResume';
import { api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { AttachmentItems } from '../../Res/AttachmentItems';

export const OtherData_attachment = "attachment"
export function ContractorResumeAttachment({ rId, attachment, companyId, setIsLoading, isEdit, isEmployee=false }) {
    const [resumeId, setResumeId] = useState("")
    const [mAttachment, setmAttachment] = useState({})
    const [mAttachmentList, setAttachmentList] = useState([])

    var parameterArray = [
        { key: "resume", name: "履歷表", br: false, editInfo: false },
        { key: "IdentityPositive", name: "身分證正面", br: true, editInfo: false },
        { key: "IdentityNegative", name: "身分證正面", br: false, editInfo: false },
        { key: "IdentityNegative", name: "薪轉存摺封面", br: true, editInfo: false },
        { key: "DispatchContract1", name: "派遣契約 1", br: true, editInfo: true },
        { key: "DispatchContract2", name: "派遣契約 2", br: false, editInfo: true },
        { key: "DispatchContract3", name: "派遣契約 3", br: false, editInfo: true },
        { key: "DispatchContract4", name: "派遣契約 4", br: false, editInfo: true },
        { key: "DispatchContract5", name: "派遣契約 5", br: false, editInfo: true },
        { key: "other1", name: "其他附件 1", br: true, editInfo: true },
        { key: "other2", name: "其他附件 2", br: false, editInfo: true },
        { key: "other3", name: "其他附件 3", br: false, editInfo: true },
    ]

    useEffect(() => {
        if (rId !== undefined && rId !== "" && rId !== resumeId) {
            setResumeId(rId)
            //console.log(rId)
            //getResumeOtherData(rId)
        }
    }, [rId])

    useEffect(() => {
        //console.log(attachment)
        if (attachment !== undefined && attachment !== mAttachment && Object.keys(attachment).length !== 0) {
            setmAttachment(attachment)
            var mRespResumeOtherDataAttachmentList = new RespResumeOtherDataAttachmentList({})
            mRespResumeOtherDataAttachmentList.fromJson(attachment.resumeData, parameterArray)
            console.log(mRespResumeOtherDataAttachmentList)
            setAttachmentList(mRespResumeOtherDataAttachmentList.attachmentList)
        }
    }, [attachment])


    function setAttachment(key, attachment) {
        //console.log(key)
        //console.log(attachment)
        //console.log(mAttachmentList)
        mAttachmentList[key] = attachment
        setAttachmentList(mAttachmentList)
    }

    async function saveOtherDataAttachment() {
        //console.log("saveOtherData")
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_attachment,
            resumeData: JSON.stringify(mAttachmentList),
        })
        try {
            await api_addResumeOtherData({
                mRespResumeOtherData,
                isEmployee
            })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: "儲存成功",
            })
        } catch (error) {
            console.log(error)
        }
    }



    var title = "附件資料"
    var content =
        <>
            {
                parameterArray.map((f, i) => (
                    <AttachmentItems key={"pm" + i} index={f.key} parameter={f} attachment={mAttachmentList[f.key]} setAttachment={setAttachment} isEdit={isEdit} />
                ))
            }
            {isEdit ?
                <>
                    <div class="hr-line-dashed"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-2">
                                <p>支援的檔案格式</p>
                            </div>
                            <div class="col-md-10">
                                <strong>文件：&nbsp;.pdf&nbsp;&nbsp;.doc&nbsp;&nbsp;.docx&nbsp;&nbsp;；&nbsp;&nbsp;圖片：&nbsp;.jpg&nbsp;&nbsp;.jpeg&nbsp;&nbsp;.png；&nbsp;&nbsp;檔案大小&lt; 5MB   </strong>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <span style={{ lineHeight: "35px" }}>請注意！未按下儲存，檔案不會改變</span>
                            <SubmitButton name={"儲存"} action={saveOtherDataAttachment} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={true} />
        </>
    )
}
